import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Version')
export class Version {

  @JsonProperty('version_id', Number)
  versionId: number = 0;

  @JsonProperty('api_version', String)
  apiVersion: string = '';

  @JsonProperty('min_app_version', String)
  minAppVersion: string = '';

  @JsonProperty('game_server_version', String)
  gameServerVersion: string = '';

  @JsonProperty('is_active', Boolean)
  isActive: boolean = false;
}
